<div class="Flexbox Marginbox__t-tiny Flexbox__flex-1 filter-from-padding">
    <div class="Marginbox__r-medium Flexbox__flex-1 Flexbox Flexbox__box-align-center range-filter">
      <span class="Marginbox__r-regular text" >{{'from' | translate }}</span>
      <input type="number" class="removeArrowButton filter-height filter-padding input" id="fromInput" [(ngModel)]="filter.selectedValue.from">
      <span class="Marginbox__l-regular">{{filter.config.unit}}</span>
      </div>
    <div class="Flexbox__flex-1 Flexbox Flexbox__box-align-center range-filter" >
      <span class="Marginbox__r-regular text ">{{'to' | translate}}</span>
      <input type="number" class="removeArrowButton filter-height filter-padding input" id="toInput" [(ngModel)]="filter.selectedValue.to">
      <span class="Marginbox__l-regular">{{filter.config.unit}}</span>
    </div>
  </div>
